import type {
    AppModule,
    AppSubmodule,
    ExposedMenu,
    MenuGroup,
    SideLink,
} from '@moniebook-web/components/widgets/sidebar';
import { RestartLine } from '@moniebook-web/icons/device/restart-line';
import { FileChartLine } from '@moniebook-web/icons/document/file-chart-line';
import { ShoppingBasketLine } from '@moniebook-web/icons/finance/shopping-basket-line';
import { MENU_SECTIONS } from '@moniebook-web/types';

const ONBOARDING_SIDEBAR_COLOR = '#FF8C00';

const ENABLE_INVENTORY_ONBOARDING = 'moniebook.pos.inventoryOnboarding';

export const inventoryOnboardingMenu: ExposedMenu = {
    menuGroups: [
        {
            id: 'onboarding',
            name: 'Onboarding',
            order: 1,
            icon: <FileChartLine />,
            sectionId: MENU_SECTIONS.INVENTORY,
            color: ONBOARDING_SIDEBAR_COLOR,
        },
    ] as MenuGroup[],
    submenu: [
        {
            sectionId: 'onboarding',
            parentId: 'onboarding',
            order: 1,
            to: 'onboarding/import-file',
            name: 'Import file',
            icon: <RestartLine />,
            grantAccessIfAny: true,
            featureFlag: ENABLE_INVENTORY_ONBOARDING,
        },
        {
            sectionId: 'onboarding',
            parentId: 'onboarding',
            order: 3,
            to: 'onboarding/add-items',
            name: 'Add items',
            icon: <ShoppingBasketLine />,
            grantAccessIfAny: true,
            featureFlag: ENABLE_INVENTORY_ONBOARDING,
        },
    ] as SideLink[],
    modules: [
        {
            id: 'inventory_onboarding',
            name: 'Inventory Onboarding',
            order: 6,
            icon: <FileChartLine />,
            backgroundColor: '#F5D0FE',
            foregroundColor: '#E979F9',
        },
    ] as AppModule[],
    subModules: [
        {
            parentId: 'inventory_onboarding',
            order: 1,
            to: 'onboarding/import-file',
            name: 'Import file',
            icon: <RestartLine />,
            grantAccessIfAny: true,
            featureFlag: ENABLE_INVENTORY_ONBOARDING,
        },
        {
            parentId: 'inventory_onboarding',
            order: 3,
            to: 'onboarding/add-items',
            name: 'Add items',
            icon: <ShoppingBasketLine />,
            grantAccessIfAny: true,
            featureFlag: ENABLE_INVENTORY_ONBOARDING,
        },
    ] as AppSubmodule[],
};
